<template>
    <div>
        <div id="aqumulate_integration">
            <div v-if="active">
                <label>
                    Username <v-text-field type="text" :value="usernameProp" :readonly="active"/>
                </label>
                Last updated at: {{ {time: lastUpdated, timezone: 'America/New_York'} | formatDateTimeWithTz }}
                <v-btn
                    class="mr-2"
                    color="primary"
                    title="Manually trigger accounts update."
                    @click="pullAqumulateAccountsData">Pull Accounts</v-btn>
                <v-btn class="error" @click="disconnectAqumulate">Delete</v-btn>
            </div>
            <div v-else>
                Username <v-text-field type="text" v-model="username"/>
                Password <v-text-field type="password" v-model="password"/>
                <v-btn
                    color="primary"
                    @click="connectAqumulate">Connect</v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapMutations} from "vuex";

export default {
        props: {
        active: {
            type: Boolean,
            default: false
        },
        lastUpdated: {
            type: String,
            default: ''
        },
        usernameProp: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            username: this.username,
            password: null,
        }
    },

    inject: ['householdId'],

    methods: {
        ...mapMutations('loader', [
            'show',
            'hide'
        ]),
        ...mapActions('household', ['fetchHouseholdAccountData']),
        ...mapActions('aqumulate', [
            'connect',
            'disconnect',
            'pullAccountsData',
        ]),
        connectAqumulate() {
            this.show();
            this.connect({credential: {username: this.username, password:this.password}, householdId: this.householdId})
                .then(() => {
                    // Now we are connected, we should re-query accounts.
                    return this.fetchHouseholdAccountData(this.householdId);
                })
                .finally(() => this.hide());
        },
        disconnectAqumulate() {
            if(window.confirm('Please confirm again to delete this integration. Note that previously connected accounts will remain in the system.')) {
                this.show()
                this.disconnect(this.householdId)
                    .then(() => {
                        // Re-query accounts.
                        return this.fetchHouseholdAccountData(this.householdId);
                    })
                    .finally(() => this.hide());
            }
        },
        pullAqumulateAccountsData() {
            this.show()
            this.pullAccountsData(this.householdId)
                .then(() => this.fetchHouseholdAccountData(this.householdId))
                .finally(() => this.hide());
        }
    }
}

</script>
